import config from "../config/config.json";
import { headers } from "./../APIHelpers/Headers";
import {
  handleResponse,
  headersWithAuth,
  headersWithAuthWithoutBody,
} from "../APIHelpers/Responses";

export const studyProtocolReviewServices = {
  addNewStudyProtocolReview,
  updateStudyProtocolReview,
  getStudyProtocolReview,
  softDeleteRestoreStudyProtocolReview,
  deleteStudyProtocolReview,
};

async function addNewStudyProtocolReview(userData) {
  const response = await fetch(
    `${config.API_URL}addNewStudyProtocolReview`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  // handleResponse(data);
  return data;
}

async function updateStudyProtocolReview(userData) {
  const response = await fetch(
    `${config.API_URL}updateStudyProtocolReview`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  // handleResponse(data);
  return data;
}

async function softDeleteRestoreStudyProtocolReview(userData) {
  const response = await fetch(
    `${config.API_URL}softDeleteRestoreStudyProtocolReview`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  // handleResponse(data);
  return data;
}

async function deleteStudyProtocolReview(userData) {
  const response = await fetch(
    `${config.API_URL}deleteStudyProtocolReview`,
    headersWithAuth("DELETE", userData, headers)
  );
  const data = await response.json();
  // handleResponse(data);
  return data;
}

async function getStudyProtocolReview(reviewType, status, projectId, page, length) {
  const query = new URLSearchParams();
  if (projectId) query.append("projectId", projectId);
  if (page && length) {
    query.append("page", page);
    query.append("length", length);
  }

  const response = await fetch(
    `${config.API_URL}getStudyProtocolReview/${reviewType}/${status}?${query.toString()}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}
